import { useDispatch, useSelector } from "react-redux";
import { useDeleteProjectMutation } from "../../features/projects/projectsApi";
import {
  controlConfirmationDialog,
  setIdToBeDeleted,
} from "../../features/projects/projectSlice";

export default function ConfirmationDialog({ open }) {
  const dispatch = useDispatch();
  const id = useSelector((state) => state.projects.idToBeDeleted);

  //Logged in User
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};

  //Query
  const [deleteProject] = useDeleteProjectMutation();

  const handleDeleteProject = async () => {
    await deleteProject({ id, creator: loggedInUser });
    dispatch(setIdToBeDeleted(0));
    dispatch(controlConfirmationDialog());
  };
  return (
    open && (
      <>
        <div
          onClick={() => dispatch(controlConfirmationDialog())}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="text-center rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <h2 className="text-3xl font-extrabold text-gray-900">
            Confirmation!
          </h2>
          <h6 className="text-xl">
            Are you sure you wanted to delete the project?
          </h6>
          <div className="flex items-center justify-center gap-10">
            <button
              onClick={handleDeleteProject}
              className="text-white bg-green-600 hover:bg-green-700 px-10 py-2 rounded"
            >
              Yes
            </button>
            <button
              onClick={() => dispatch(controlConfirmationDialog())}
              className="text-white bg-red-600 hover:bg-red-700 px-10 py-2 rounded"
            >
              No
            </button>
          </div>
        </div>
      </>
    )
  );
}
